import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../Config/config';

function Skills() {

    // const [progressItems, setProgressItems] = useState([]);

    // useEffect(() => {
    //     axios.get(`${BASE_URL}/skill`)
    //         .then(response => {
    //             setProgressItems(response.data);
    //         })
    //         .catch(error => {
    //             console.error('Error fetching progress items:', error);
    //         });
    // })

    const progressItems = [
        {
            heading: "Projects Completed",
            count: "150+",
            percentage: 90
        },
        {
            heading: "Happy Clients",
            count: "120+",
            percentage: 80
        },
        {
            heading: "Team Members",
            count: "25",
            percentage: 70
        },
        {
            heading: "Years of Experience",
            count: "5+",
            percentage: 60
        }
    ];
    

    useEffect(() => {
        const kalProgress = () => {
            const progress = document.querySelectorAll('.progress-rate');
            progress.forEach((item) => {
                const dataValue = item.getAttribute('data-value');
                item.style.width = dataValue + '%';
            });
        };
        const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const progressRateClass = document.getElementById('progress-running');
            if (progressRateClass) {
                const progressOffset = progressRateClass.offsetTop - windowHeight;
                if (window.scrollY > progressOffset) {
                    kalProgress();
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className="col-lg-5">
                <div className="animated fadeInRight" data-wow-duration="1s" data-wow-delay="0.3s">
                    <div className="all-progress" id="progress-running">
                        {progressItems.map((progress, index) => (
                            <>
                                <div className="progress-item" key={index}>
                                    <span className="progress-heading">{progress.heading}</span>
                                    <span className="progress-count">{progress.count}</span>
                                    <div className="progress-bg">
                                        <div id='progress-one' className="progress-rate" data-value={progress.percentage}>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            </div></>
    )
}

export default Skills